<app-breadcrumb></app-breadcrumb>

<div class="subscription-success">
  <div class="subscription-success__content">
    <div class="subscription-success__header">
      <svg class="subscription-success__icon" viewBox="0 0 20 20" aria-hidden="true">
        <circle cx="10" cy="10" r="10" fill="currentColor" />
        <path
          d="M8.6 13.4 5.9 10.7l1-1 1.7 1.7 4.5-4.5 1 1z"
          fill="#fff"
        />
      </svg>

      <h2 class="subscription-success__title">{{ texts.title }}</h2>
    </div>

    <div class="subscription-success__block">
      <h3 class="subscription-success__subtitle">{{ texts.whatNowTitle }}</h3>
      <p class="subscription-success__text">{{ texts.whatNowText }}</p>
    </div>

    <div class="subscription-success__block">
      <h3 class="subscription-success__subtitle">{{ texts.voucherTitle }}</h3>
      <p *ngIf="hasEmail; else withoutEmail" class="subscription-success__text">
        {{ texts.voucherTextStart
        }}<span class="subscription-success__email">{{ subscription?.email }}</span
        >{{ texts.voucherTextEnd }}
      </p>

      <ng-template #withoutEmail>
        <p class="subscription-success__text">
          {{ texts.voucherWithoutEmailText
          }}<a class="subscription-success__link" [routerLink]="personalDataUrl">{{
            texts.voucherWithoutEmailLink
          }}</a>
        </p>
      </ng-template>
    </div>

    <div class="subscription-success__groups">
      <dl class="subscription-success__details">
        <div *ngFor="let detail of voucherDetails" class="subscription-success__detail">
          <dt class="subscription-success__detail-label">{{ detail.label }}</dt>
          <dd class="subscription-success__detail-value">{{ detail.value }}</dd>
        </div>
      </dl>

      <dl class="subscription-success__details">
        <div *ngFor="let detail of dateDetails" class="subscription-success__detail">
          <dt class="subscription-success__detail-label">{{ detail.label }}</dt>
          <dd class="subscription-success__detail-value">{{ detail.value }}</dd>
        </div>
      </dl>

      <dl class="subscription-success__details">
        <div *ngFor="let detail of fundDetails" class="subscription-success__detail">
          <dt class="subscription-success__detail-label">{{ detail.label }}</dt>
          <dd class="subscription-success__detail-value">{{ detail.value }}</dd>
        </div>
      </dl>
    </div>

    <ds-inline-alert
      class="subscription-success__notice"
      type="info"
      emphasis="outline"
      size="m"
      [title]="texts.noticeTitle"
    >
      <ul class="subscription-success__notice-list">
        <li *ngFor="let notice of texts.notices">{{ notice }}</li>
      </ul>
    </ds-inline-alert>

    <div class="subscription-success__actions">
      <div *ngIf="hasVoucher" class="subscription-success__action">
        <ds-button-v2
          emphasis="primary"
          size="m"
          trailingIcon="Download"
          [fullWidth]="true"
          maxWidth="100%"
          [label]="texts.downloadButton"
          (clicked)="downloadMyFile()"
        ></ds-button-v2>
      </div>

      <div class="subscription-success__action">
        <ds-button-v2
          emphasis="secondary-outlined"
          size="m"
          [fullWidth]="true"
          maxWidth="100%"
          [label]="texts.homeButton"
          (clicked)="goHome()"
        ></ds-button-v2>
      </div>
    </div>
  </div>
</div>
